import { motion } from 'framer-motion';
import Button from '../ui/Button';

export default function CTASection({ onAuthOpen }) {
  return (
    <section className="cta-section" style={{ padding: 'var(--space-12) 0', textAlign: 'center' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        style={{
          background: 'var(--accent-gradient)',
          borderRadius: 'var(--radius-xl)',
          padding: 'var(--space-10) var(--space-6)',
          maxWidth: '800px',
          margin: '0 auto',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: 'var(--shadow-xl)'
        }}
      >
        {/* Background decorations */}
        <div style={{ position: 'absolute', top: '-50%', left: '-20%', width: '300px', height: '300px', background: 'rgba(255,255,255,0.1)', borderRadius: '50%', filter: 'blur(40px)' }}></div>
        <div style={{ position: 'absolute', bottom: '-50%', right: '-20%', width: '300px', height: '300px', background: 'rgba(0,0,0,0.2)', borderRadius: '50%', filter: 'blur(40px)' }}></div>

        <div style={{ position: 'relative', zIndex: 1 }}>
          <h2 style={{ fontSize: 'var(--text-3xl)', fontWeight: 800, color: '#fff', marginBottom: 'var(--space-4)' }}>
            Yelkenlerini Açmaya Hazır Mısın?
          </h2>
          <p style={{ fontSize: 'var(--text-lg)', color: 'rgba(255,255,255,0.9)', marginBottom: 'var(--space-8)', maxWidth: '500px', margin: '0 auto var(--space-8)' }}>
            Türkiye'nin en disiplinli öğrencileri arasına katıl. Tamamen ücretsiz başla, sınırlarını zorla.
          </p>
          
          <Button 
            variant="primary" 
            size="xl" 
            onClick={onAuthOpen}
            style={{ 
              background: '#fff', 
              color: 'var(--accent-primary)', 
              boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
              fontWeight: 700
            }}
          >
            Hemen Ücretsiz Kayıt Ol
          </Button>
          <p style={{ marginTop: 'var(--space-4)', fontSize: 'var(--text-xs)', color: 'rgba(255,255,255,0.7)' }}>
            Kredi kartı gerekmez. Sadece e-posta veya Google ile giriş yap.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
